<template>
    <div class="main box">
        <h1>IFU Lots</h1>

        <div class="import-container">
            <div class="import-label">
                Import lots (.xlsx) — columns: <strong>Lot</strong>, <strong>Gamme</strong> (ps/va/lc/cc), <strong>Statut</strong> (MDD/MDR)
            </div>
            <div class="import-row">
                <input type="file" accept=".xlsx,.xls" @change="handleFileChange" ref="fileInput" />
                <div class="btn" :class="{ disabled : !file || importing }" @click="importFile">{{ importing ? "Importing..." : "Import" }}</div>
            </div>
            <div class="import-result" v-if="importResult">
                <p>{{ importResult.inserted }} inserted, {{ importResult.updated }} updated.</p>
                <div class="import-errors" v-if="importResult.errors.length">
                    <p class="errors-title">{{ importResult.errors.length }} row(s) skipped :</p>
                    <div v-for="(err, idx) in importResult.errors" :key="idx" class="error-line">{{ err }}</div>
                </div>
            </div>
            <div class="notices errors" v-if="importError">{{ importError }}</div>
        </div>

        <div class="filter-container">
            <input type="text" placeholder="Search a lot number" v-model="search" @keyup="getData" class="btn-search" />
        </div>

        <div class="table-container">
            <table class="cards">
                <thead>
                    <tr>
                        <th>Lot number</th>
                        <th>Range</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in list" :key="item._id">
                        <td data-label="Lot number">{{ item.lotNumber }}</td>
                        <td class="uppercase" data-label="Range">{{ item.range }}</td>
                        <td data-label="Status"><span :class="['status-badge', item.regulatoryStatus.toLowerCase()]">{{ item.regulatoryStatus }}</span></td>
                        <td data-label="Actions">
                            <div class="post-btn icon-otw_icon_trash" @click="confirmId = item._id"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="modal" v-if="confirmId">
            <div class="modal-container">
                <h3>Please confirm deletion of this lot</h3>
                <div class="btns-container">
                    <div class="btn btn-cancel" @click="confirmId = null">Cancel</div>
                    <div class="btn btn-confirm" @click="deleteLot">Confirm</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name : "IfuLots",
    data() {
        return {
            list : [],
            search : null,
            file : null,
            importing : false,
            importResult : null,
            importError : null,
            confirmId : null
        }
    },
    methods : {
        getData() {
            let config = {
                validateStatus: () => true,
            };
            config.headers = { 'x-access-token' : localStorage._safeToken }
            let vm = this;
            axios
                .get(`${this.$store.state.apiUrl}/ifu/lots/${this.search || "null"}`, config)
                .then(function (res) {
                    if(res.status != 200) {
                        const notice = {
                            msg : res.data.errors,
                            error : true
                        }
                        vm.$store.commit('setNotice', notice);
                    }else {
                        vm.list = res.data.message;
                    }
                })
                .catch(function () {
                    vm.$store.commit('setNotice', { msg : "Unable to reach the API", error : true });
                });
        },
        handleFileChange(event) {
            this.file = event.target.files[0] || null;
            this.importResult = null;
            this.importError = null;
        },
        importFile() {
            if(!this.file || this.importing) return;

            const formData = new FormData();
            formData.append('file', this.file);

            let config = {
                validateStatus: () => true,
            };
            config.headers = { 'Content-Type': 'multipart/form-data', 'x-access-token' : localStorage._safeToken }
            let vm = this;
            this.importing = true;
            this.importResult = null;
            this.importError = null;
            axios
                .post(`${this.$store.state.apiUrl}/ifu/import`, formData, config)
                .then(function (res) {
                    vm.importing = false;
                    if(res.status != 200) {
                        vm.importError = res.data.errors;
                    }else {
                        vm.importResult = res.data.message;
                        vm.file = null;
                        vm.$refs.fileInput.value = null;
                        vm.getData();
                    }
                })
                .catch(function () {
                    vm.importing = false;
                    vm.importError = "Unable to reach the API";
                });
        },
        deleteLot() {
            let config = {
                validateStatus: () => true,
            };
            config.headers = { 'x-access-token' : localStorage._safeToken }
            let vm = this;
            let id = this.confirmId;
            axios
                .delete(`${this.$store.state.apiUrl}/ifu/lot/${id}`, config)
                .then(function (res) {
                    if(res.status != 200) {
                        const notice = {
                            msg : res.data.errors,
                            error : true
                        }
                        vm.$store.commit('setNotice', notice);
                    }else {
                        vm.list = vm.list.filter(e => e._id != id);
                    }
                    vm.confirmId = null;
                })
                .catch(function () {
                    vm.$store.commit('setNotice', { msg : "Unable to reach the API", error : true });
                    vm.confirmId = null;
                });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
    h1 {
        color:#fff;
        text-align: center;
        font-size:25px;
        text-transform: uppercase;
        font-weight: 300;
        margin:40px auto;
    }

    .import-container {
        margin: 0 auto 40px auto;
        padding: 20px;
        border: 1px solid #333;
    }

    .import-label {
        color:#fff;
        font-size:14px;
        margin-bottom:15px;
    }

    .import-row {
        display: flex;
        align-items: center;
    }

    input[type="file"] {
        color:#fff;
        margin-right:20px;
    }

    .btn.disabled {
        opacity:0.5;
        cursor: not-allowed;
    }

    .import-result {
        margin-top:15px;
        color:#fff;
    }

    .errors-title {
        color:$red;
        margin-bottom:5px;
    }

    .error-line {
        color:$red;
        font-size:13px;
    }

    .filter-container {
        margin-bottom:20px;
        display: flex;
        justify-content: flex-end;
    }

    .btn-search {
        min-width:250px;
    }

    .uppercase {
        text-transform: uppercase;
    }

    .status-badge {
        padding:3px 10px;
        font-size:12px;
        text-transform: uppercase;
        border:1px solid $mainColor;
        color:$mainColor;
    }

    .status-badge.mdr {
        background:$mainColor;
        color:#000;
    }

    .modal {
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        z-index:1;
        background:rgba(255,255,255, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-container {
        padding:40px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background:#000;
        width:500px;
    }

    .modal-container h3 {
        font-size:20px;
        color:#fff;
        text-align: center;
        font-weight: 300;
    }

    .btns-container {
        display: flex;
        margin-top:20px;
    }

    .btns-container .btn {
        margin:0 20px;
    }

    .btn-cancel {
        background:#000;
        border:1px solid #fff;
    }

    .btn-cancel:hover {
        background:#fff;
        color:#000;
    }

    @media (max-width: 700px) {
        .import-row {
            flex-direction: column;
            align-items: stretch;
            gap:15px;
        }

        input[type="file"] {
            margin-right:0;
            max-width:100%;
        }

        .btn-search {
            min-width:0;
            width:100%;
        }

        .filter-container {
            justify-content: stretch;
        }
    }
</style>
